import { render, staticRenderFns } from "./speech-audio-controls.vue?vue&type=template&id=46089af7&scoped=true"
import script from "./speech-audio-controls.vue?vue&type=script&lang=ts"
export * from "./speech-audio-controls.vue?vue&type=script&lang=ts"
import style0 from "./speech-audio-controls.vue?vue&type=style&index=0&id=46089af7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46089af7",
  null
  
)

export default component.exports